import '@/styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { toast } from 'sonner';
import { registerSW } from 'virtual:pwa-register';

import { App } from '@/app/App';
import { applyTheme } from '@/lib/theme';
import { useSettingsStore } from '@/stores/settings-store';

// Apply the persisted theme before the first paint to avoid a flash.
applyTheme(useSettingsStore.getState().theme);

if (import.meta.env.PROD) {
  const updateServiceWorker = registerSW({
    immediate: true,
    onNeedRefresh() {
      toast('A new FlowShare version is ready.', {
        action: {
          label: 'Reload',
          onClick: () => {
            void updateServiceWorker(true);
          },
        },
        duration: 20_000,
      });
    },
    onOfflineReady() {
      toast.success('FlowShare is cached for offline use.');
    },
    onRegisterError(error) {
      console.warn('Service worker registration failed', error);
    },
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('FlowShare root element is missing');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
